export const fmtGNF = (n) =>
  `${Math.round(Number(n) || 0).toLocaleString("fr-FR").replace(/\u202f/g, " ")} GNF`;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const ORDER_STATUSES = [
  "Commande reçue",
  "Paiement en attente",
  "Paiement confirmé",
  "Préparation",
  "Prête pour livraison",
  "Expédiée",
  "Livrée",
  "Annulée",
  "Retournée",
];

export const STATUS_STYLES = {
  "Commande reçue": "bg-slate-100 text-slate-800 border-slate-300",
  "Paiement en attente": "bg-amber-100 text-amber-800 border-amber-300",
  "Paiement confirmé": "bg-blue-100 text-blue-800 border-blue-300",
  "Préparation": "bg-purple-100 text-purple-800 border-purple-300",
  "Prête pour livraison": "bg-teal-100 text-teal-800 border-teal-300",
  "Expédiée": "bg-indigo-100 text-indigo-800 border-indigo-300",
  "Livrée": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "Annulée": "bg-rose-100 text-rose-800 border-rose-300",
  "Retournée": "bg-orange-100 text-orange-800 border-orange-300",
};

export const PAYMENT_STATUS_STYLES = {
  "en attente": "bg-amber-100 text-amber-800 border-amber-300",
  "payé": "bg-emerald-100 text-emerald-800 border-emerald-300",
  "échoué": "bg-rose-100 text-rose-800 border-rose-300",
  "remboursé": "bg-slate-100 text-slate-800 border-slate-300",
};

export const PAYMENT_METHODS = [
  {
    id: "orange_money",
    label: "Orange Money",
    hint: "Payez à la commande depuis votre téléphone, puis saisissez la référence",
    color: "border-[#FF6600] bg-[#FF6600] text-white",
  },
  {
    id: "mtn_momo",
    label: "MTN Mobile Money",
    hint: "Payez à la commande depuis votre téléphone, puis saisissez la référence",
    color: "border-[#E6B800] bg-[#FFCC00] text-black",
  },
  {
    id: "bank_transfer",
    label: "Virement / dépôt bancaire",
    hint: "Virement ou dépôt en agence, référence du bordereau à saisir",
    color: "border-slate-800 bg-slate-900 text-white",
  },
];

export const unitPriceFor = (product, qty) => {
  if (!product) return 0;
  const wp = product.wholesale_price;
  const wq = product.wholesale_min_qty;
  if (wp && wq && qty >= wq) return Number(wp);
  return Number(product.price);
};

export const whatsappLink = (order, statusOverride) => {
  const phone = String(order.phone || "").replace(/[^0-9]/g, "");
  const status = statusOverride || order.status;
  const message =
    `Bonjour ${order.customer_name}, EMPIRE-SHOP à l'écoute.\n` +
    `Votre commande ${order.number} (${fmtGNF(order.total)}) est maintenant : ${status}.\n` +
    `Livraison : ${order.zone_name}${order.zone_eta ? ` (${order.zone_eta})` : ""}.\n` +
    `Paiement : ${order.payment_method_label} — ${order.payment_status}.\n` +
    `Merci de votre confiance.`;
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
};

export const VENDOR_STATUS_STYLES = {
  pending: "bg-amber-100 text-amber-800 border-amber-300",
  approved: "bg-emerald-100 text-emerald-800 border-emerald-300",
  suspended: "bg-rose-100 text-rose-800 border-rose-300",
  rejected: "bg-slate-100 text-slate-700 border-slate-300",
};

export const VENDOR_STATUS_LABELS = {
  pending: "En attente",
  approved: "Validé",
  suspended: "Suspendu",
  rejected: "Refusé",
};

export const MOVEMENT_TYPES = [
  { id: "entree", label: "Entrée de stock" },
  { id: "sortie", label: "Sortie de stock" },
  { id: "ajustement", label: "Ajustement (valeur exacte)" },
  { id: "retour", label: "Retour client" },
  { id: "endommage", label: "Produit endommagé" },
];

export const TRANSFER_STATUS_STYLES = {
  "en attente": "border-amber-700 bg-amber-950 text-amber-300",
  "validé": "border-emerald-700 bg-emerald-950 text-emerald-300",
  "refusé": "border-rose-800 bg-rose-950 text-rose-300",
};
